import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Language, isValidVerificationLink, LegalEntityRegistrationStorage } from '../../../utils';
import { user as userActions } from '../../../actions';
import makeClasses from '../styles';
import { toast } from "react-toastify";


const StepSix = ({ history, nextStep, prevStep, handleChange, stepOneData }) => {

    const dispatch = useDispatch();
    const classes = makeClasses();

    const { loading, languageTexts } = useSelector(state => ({
        loading: state.user.loading,
        languageTexts: state.language.texts || {},
    }));

    const i18n = Language(languageTexts);

    const [affiliationVerificationLink, setAffiliationVerificationLink] = useState(null);

    useEffect(
        () => {
            const requestCameraPermission = async () => {
                await navigator.mediaDevices.getUserMedia({
                    video: true,
                });
            };
            requestCameraPermission();
        }, [affiliationVerificationLink]);

    useEffect(
        () => {
            const cachedLink = LegalEntityRegistrationStorage.getStep6VerificationLink();

            if (cachedLink && isValidVerificationLink(cachedLink)) {
                setAffiliationVerificationLink(cachedLink);
            } else {
                dispatch(
                    userActions.merchantAffiliationIdentityVerification(stepOneData, result => {
                        if (result && result.expired) {
                            setAffiliationVerificationLink(null);
                            LegalEntityRegistrationStorage.clearStep6();
                            toast.error(i18n.get('LegalEntityRegistration.ErrorAffiliationExpired'), { autoClose: 10000 });
                        } else if (result && result.verificationLink) {
                            const safeLink = result.verificationLink;
                            if (isValidVerificationLink(safeLink)) {
                                setAffiliationVerificationLink(safeLink);
                                LegalEntityRegistrationStorage.setStep6VerificationLink(safeLink);
                            } else {
                                setAffiliationVerificationLink(null);
                                LegalEntityRegistrationStorage.clearStep6();
                                toast.error(i18n.get('LegalEntityRegistration.AlertInvalidVerificationLink'), { autoClose: 5000 });
                            }
                        } else {
                            setAffiliationVerificationLink(null);
                            LegalEntityRegistrationStorage.clearStep6();
                            toast.error(i18n.get('LegalEntityRegistration.IdentityVerificationError'), { autoClose: 5000 });
                        }
                    })
                );
            }
        },
        []
    );

    return (
        <React.Fragment>
            <div className={classes.formContent}>
                <div className={classes.formTitleContainer}>
                    <div className={classes.formTitle}>{i18n.get('LegalEntityRegistration.StepFormTitle')}</div>
                    {!affiliationVerificationLink ? (
                        <div className={classes.formText}>{i18n.get('LegalEntityRegistration.Step6FormText')}</div>
                    ) : null}
                </div>
            </div>
            {affiliationVerificationLink ? (
                <div className={classes.iframeContainer}>
                    <iframe src={affiliationVerificationLink} title="Verification" allow="camera *;" />
                </div>
            ) : null}
        </React.Fragment>
    );
}
StepSix.id = 'com.Handy.LegalEntityRegistration.StepSix';
export default StepSix;
